import { useTranslation } from "react-i18next";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20organic%20shapes%20in%20warm%20terracotta%20peach%20and%20soft%20coral%20tones%20blending%20into%20creamy%20ivory%2C%20gentle%20watercolor%20style%20gradient%20with%20subtle%20texture%2C%20minimalist%20modern%20design%2C%20clean%20aesthetic%2C%20soft%20diffused%20lighting%2C%20elegant%20composition%20suitable%20for%20website%20hero%20background%2C%20no%20text%20no%20logos%20no%20typography&width=1800&height=1200&seq=hero-bg-v2-2026&orientation=landscape"
          alt="OOPBUY Spreadsheet background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28">
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/90 backdrop-blur-sm mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-500"></span>
              <span className="text-xs md:text-sm font-medium text-foreground-800 whitespace-nowrap">
                {t("hero.badge")}
              </span>
            </div>

            <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 leading-[1.08] mb-6">
              {t("hero.title_line1")}
              <br />
              {t("hero.title_line2")}
              <br />
              {t("hero.title_line3")}
            </h1>

            <p className="text-base md:text-lg text-background-100/90 max-w-lg mx-auto lg:mx-0 mb-8 leading-relaxed">
              {t("hero.description")}
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold cursor-pointer whitespace-nowrap hover:bg-primary-600 transition-colors"
              >
                {t("hero.cta_primary")}
              </a>
              <a
                href="#categories"
                className="px-6 py-3 rounded-full border border-background-50/40 text-background-50 text-sm md:text-base font-medium cursor-pointer whitespace-nowrap hover:bg-background-50/10 transition-colors"
              >
                {t("hero.cta_secondary")}
              </a>
            </div>
          </div>

          <div className="hidden lg:block flex-1">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20fashion%20product%20flatlay%20with%20sneakers%20hoodie%20and%20designer%20accessories%20arranged%20artistically%20on%20warm%20sandstone%20textured%20surface%2C%20soft%20golden%20hour%20lighting%20casting%20gentle%20shadows%2C%20high%20end%20minimalist%20product%20photography%2C%20rich%20warm%20earth%20tones%20with%20subtle%20olive%20accents%2C%20sophisticated%20organic%20composition&width=900&height=1200&seq=hero-side-v2-2026&orientation=portrait"
                alt="Product sourcing categories"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}